module.exports = __webpack_public_path__ + "static/img/title.7030bead.png";